const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GTAG_SCRIPT_ID = "ga-gtag";

let isInitialized = false;

export const isGaConfigured =
  typeof GA_MEASUREMENT_ID === "string" && GA_MEASUREMENT_ID.trim() !== "";

export function initGoogleAnalytics() {
  if (!isGaConfigured || isInitialized) return;

  if (!document.getElementById(GTAG_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.id = GTAG_SCRIPT_ID;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ??
    function gtag(...args: unknown[]) {
      window.dataLayer?.push(args);
    };

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  isInitialized = true;
}

export function trackPageView(path: string) {
  if (!isGaConfigured || !isInitialized || typeof window.gtag !== "function")
    return;

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
